import type { ApiCaseServiceAlert } from '../Utils/apiTypes';
import type { OrganizationAlertStatus } from '../Utils/types';

export type UpdateAlertStatusRequest = {
  type: 'CaseAlerts/UPDATE_ALERT_STATUS';
  organizationAlertId: number;
  donorId: number;
  status: OrganizationAlertStatus;
  createChatroom: boolean;
};

export type UpdateAlertStatusSuccess = {
  type: 'CaseAlerts/UPDATE_ALERT_STATUS_SUCCESS';
  alert: ApiCaseServiceAlert;
  donorId: number;
};

export type UpdateAlertStatusFailure = {
  type: 'CaseAlerts/UPDATE_ALERT_STATUS_FAILURE';
  error: string;
};

export type CaseAlertsAction = UpdateAlertStatusRequest | UpdateAlertStatusSuccess | UpdateAlertStatusFailure;

// Case Service Info Room Actions
export type CreateCaseServiceInfoRoomRequest = {
  type: 'CaseServiceInfoRoom/CREATE_CASE_SERVICE_INFO_ROOM';
  caseId: number;
  providerServiceId: number;
};

export type CreateCaseServiceInfoRoomSuccess = {
  type: 'CaseServiceInfoRoom/CREATE_CASE_SERVICE_INFO_ROOM_SUCCESS';
  caseId: number;
  chatroomId: number;
};

export type CreateCaseServiceInfoRoomFailure = {
  type: 'CaseServiceInfoRoom/CREATE_CASE_SERVICE_INFO_ROOM_FAILURE';
  error: string;
};

export type CaseServiceInfoRoomAction =
  | CreateCaseServiceInfoRoomRequest
  | CreateCaseServiceInfoRoomSuccess
  | CreateCaseServiceInfoRoomFailure;

export const updateAlertStatus = (
  organizationAlertId: number,
  donorId: number,
  status: OrganizationAlertStatus,
  createChatroom: boolean,
): UpdateAlertStatusRequest => ({
  type: 'CaseAlerts/UPDATE_ALERT_STATUS',
  organizationAlertId,
  donorId,
  status,
  createChatroom,
});

export const updateAlertStatusSuccess = (alert: ApiCaseServiceAlert, donorId: number): UpdateAlertStatusSuccess => ({
  type: 'CaseAlerts/UPDATE_ALERT_STATUS_SUCCESS',
  alert,
  donorId,
});

export const updateAlertStatusFailure = (error: string): UpdateAlertStatusFailure => ({
  type: 'CaseAlerts/UPDATE_ALERT_STATUS_FAILURE',
  error,
});

// Case Service Info Room Action functions
export const createCaseServiceInfoRoom = (
  caseId: number,
  providerServiceId: number,
): CreateCaseServiceInfoRoomRequest => ({
  type: 'CaseServiceInfoRoom/CREATE_CASE_SERVICE_INFO_ROOM',
  caseId,
  providerServiceId,
});

export const createCaseServiceInfoRoomSuccess = (
  caseId: number,
  chatroomId: number,
): CreateCaseServiceInfoRoomSuccess => ({
  type: 'CaseServiceInfoRoom/CREATE_CASE_SERVICE_INFO_ROOM_SUCCESS',
  caseId,
  chatroomId,
});

export const createCaseServiceInfoRoomFailure = (error: string): CreateCaseServiceInfoRoomFailure => ({
  type: 'CaseServiceInfoRoom/CREATE_CASE_SERVICE_INFO_ROOM_FAILURE',
  error,
});
